import { Component, Inject, Input, OnInit } from '@angular/core';
import { NbAuthSocialLink, NB_AUTH_OPTIONS, getDeepFromObject } from '@nebular/auth';
import { AuthService } from '../../auth/auth-service.service';
import { Router } from '@angular/router';
import { User } from '../../model/user/user';
import { IdType } from '../../enums/id-type.enum';
import { Country } from '../../model/geo/country.model';
import { GeoService } from '../../services/geo.service';
import { State } from '../../model/geo/state.model';
import { City } from '../../model/geo/city.model';
import { UserService } from '../../services/user/user.service';

@Component({
  selector: 'ngx-user-register',
  templateUrl: './user-register.component.html',
  styleUrls: ['./user-register.component.scss']
})
export class UserRegisterComponent implements OnInit {

  documentTypes = IdType;
  selectedDocumentType = IdType.CE;

  public country: Country = new Country();
  public state: State = new State();
  public city: City = new City();


  redirectDelay: number = 0;
  showMessages: any = {};

  submitted = false;
  errors: string[] = [];
  messages: string[] = [];
  @Input() user: any = {};
  socialLinks: NbAuthSocialLink[] = [];
  validation = {};

  constructor(
    protected auth: AuthService,
    @Inject(NB_AUTH_OPTIONS) protected config = {},
    protected router: Router,
    protected geoService: GeoService,
    protected userService: UserService) {

    this.redirectDelay = this.getConfigValue('forms.register.redirectDelay');
    this.showMessages = this.getConfigValue('forms.register.showMessages');
    this.socialLinks = this.getConfigValue('forms.register.socialLinks');

    this.validation = this.getConfigValue('forms.validation');
    

  }

  ngOnInit(): void {

    this.geoService.getCountries().subscribe((geoSnapshot) => {
      geoSnapshot.forEach((geoData: any) => {
        this.country = geoData.payload.doc.data().country as Country;   
      })
    });    
  }

  register(): void {
    
    this.errors = this.messages = [];
    this.submitted = true;
    console.log(this.user);

    this.auth.register(this.user.email, this.user.password)
      .then((res) => {
        this.submitted = false;
        this.messages = [res.user.displayName];
        res.user.sendEmailVerification();
        this.userService.createUser(this.user, res.user.uid);
        res.user.updateProfile({
          displayName: this.user.firstName + " " + this.user.lastName,
          photoURL: ""
        }).then(function() {
          // Update successful.
        }).catch(function(error) {
          // An error happened.
        });

        res.user.updateProfile({
          displayName: this.user.firstName + " " + this.user.lastName,
          photoURL: ""
        }).then(function() {
          // Update successful.
        }).catch(function(error) {
          // An error happened.
        });
        this.redirectToVerifyAccount();
      })
      .catch((err) => {
        this.submitted = false;
        this.errors = [err];
      });


  }

  loginSocial(name) {
    if (name === "google") {
      this.loginGoogle();
    } else if (name === "facebook") {
      this.loginFb();
    } else {
      console.warn("No login for " + name);
    }
  }

  loginGoogle() {
    this.auth.signInWithGoogle()
      .then((success) => {
        this.redirectToDashboard()
      })
      .catch((err) => {
        this.errors = [err];
      });
  }

  loginFb() {
    this.auth.signInWithFacebook()
      .then((success) => {
        this.redirectToDashboard()
      })
      .catch((err) => {
        this.errors = [err];
      });
  }

  redirectToDashboard() {
    setTimeout(() => {
      this.router.navigate(['/pages/dashboard']);
    }, this.redirectDelay);
  }

  redirectToVerifyAccount(){
    setTimeout(() => {
      this.router.navigate(['/auth/verify-account']);
    }, this.redirectDelay);
  }

  getConfigValue(key: string): any {
    return getDeepFromObject(this.config, key, null);
  }

  updateState(){
    this.country.states.forEach(state => {
      if (state.name == this.user.state){
        this.state = state;
      }
    });
  }

  cities(){
    return this.state.cities;
  }
}
